import dayjs from '@/libs/dayjs';

export const toHoursAndMinutes = (totalMinutes) => {
  const hours = Math.floor(totalMinutes / 60 / 60);
  const minutes = Math.floor(totalMinutes / 60);
  const seconds = totalMinutes % 60;

  return {
    hours,
    minutes,
    seconds,
  };
};

export const getDuration = (start, end) => {
  const diff = dayjs(end).diff(dayjs(start));
  return dayjs(diff).utc().format('HH:mm:ss');
};

export const roundToDecimal = (value, decimals = 1) => {
  if (typeof value === 'string') {
    const parsedValue = Number(value);
    if (Number.isNaN(parsedValue)) {
      return NaN;
    }
    value = parsedValue;
  }
  const multiplier = Math.pow(10, decimals);
  return Math.round(value * multiplier) / multiplier;
};
